import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const StepOtherShared = () => (
  <ol>
    <li>
      <FormattedMessage {...messages.other1} />
    </li>
    <li>
      <FormattedMessage {...messages.other2} />
    </li>
    <li>
      <FormattedMessage {...messages.other3} />
    </li>
  </ol>);
export default StepOtherShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/components/StepOtherShared.js